import { useEffect } from 'react';
import { NavigationItemType } from 'framework/navigation';
import useHeaderMenuService from './headerMenuService';

interface HeaderMenuProps {
  menuData?: NavigationItemType[];
}

const HeaderMenu = ({ menuData = [] }: HeaderMenuProps) => {
  const { addMenuData } = useHeaderMenuService();

  useEffect(() => {
    addMenuData(menuData);
    // Suppressed warnings because we only need to call useCallback callback if menuData are changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuData]);

  // Display on MainNavigationTabs // DesktopHeaderMenuItems
  return null;
};

export default HeaderMenu;
